import actionTypes from "./types";

export const updateUser = (payload) => (dispatch) => {
    return dispatch({
        type: actionTypes.UPDATE_USER,
        payload,
    });
};
